var __rspack_ns_object = JSON.parse('{"Back to Viewer":"Voltar para o Viewer","Options":"Opções","Preferences":"Preferências","Study list":"Lista de estudos"}')